import React, { Component, createElement, Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { ComponentsManager } from '@comall-backend-builder/core';
import { Entity } from '@comall-backend-builder/core/lib/parser';
import { message } from 'antd';
import { errorHandle } from '../../services';
import { services } from '@comall-backend-builder/core';

const api = services.api;

export interface LiveFilterAttrTableProps {
    entity: Entity;
    params: any;
    componentId: string;
    selectedRowKeys: string[];
}
interface IState {
    selectedKeys: any;
}
class liveRoomsTable extends Component<LiveFilterAttrTableProps, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            selectedKeys: [],
        };

        this.onDeleteBatch = this.onDeleteBatch.bind(this);
        this.onBatchHide = this.onBatchHide.bind(this);
        this.onBatchShow = this.onBatchShow.bind(this);
    }

    onDeleteBatch() {
        const { entity, params } = this.props;
        const { selectedKeys } = this.state;
        if (selectedKeys.length == 0) {
            message.warning('请至少选择一项');
        } else {
            const ids = selectedKeys.join(',');
            api.post({ ids }, { apiPath: `/live/room/del/${ids}` })
                .then(() => {
                    // 列表数据刷新
                    entity.search({
                        ...entity.params,
                        ...entity.filters,
                    });
                })
                .catch(errorHandle);
        }
    }

    onBatchHide() {
        const { entity } = this.props;
        const { selectedKeys } = this.state;

        if (selectedKeys.length == 0) {
            message.warning('请至少选择一项');
        } else {
            const roomId = selectedKeys.join(',');
            api.post({ roomId, show_status: 'HIDE' }, { apiPath: `/live/room/set` })
                .then(() => {
                    // 列表数据刷新
                    entity.search({
                        ...entity.params,
                        ...entity.filters,
                    });
                })
                .catch(errorHandle);
        }
    }
    onBatchShow() {
        const { entity } = this.props;
        const { selectedKeys } = this.state;
        if (selectedKeys.length == 0) {
            message.warning('请至少选择一项');
        } else {
            const roomId = selectedKeys.join(',');
            api.post({ roomId, show_status: 'DISPLAY' }, { apiPath: `/live/room/set` })
                .then(() => {
                    // 列表数据刷新
                    entity.search({
                        ...entity.params,
                        ...entity.filters,
                    });
                })
                .catch(errorHandle);
        }
    }
    addActionBannerBtnRender() {
        const { entity } = this.props;
        const layoutProps = {
            entity: entity,
            component: 'GridLayout',
            items: [
                {
                    component: 'Button',
                    type: 'primary',
                    text: '创建直播间',
                    route: '/live-room/add',
                    span: 3,
                    style: { marginBottom: '20px' },
                },
                {
                    component: 'Button',
                    text: '批量显示',
                    span: 3,
                    style: { marginBottom: '20px' },
                    onClick: this.onBatchShow,
                },
                {
                    component: 'Button',
                    text: '批量隐藏',
                    span: 3,
                    style: { marginBottom: '20px' },
                    onClick: this.onBatchHide,
                },

                {
                    component: 'Button',
                    text: '批量删除',
                    span: 3,
                    style: { marginBottom: '20px' },
                    onClick: this.onDeleteBatch,
                },
            ],
        };
        return createElement(ComponentsManager.get('GridLayout'), layoutProps);
    }

    renderTable() {
        const { entity, componentId } = this.props;
        const liveRoomTable = {
            entity,
            rowKey: 'id',
            componentId: componentId + '-Table',
            loadFirstPage: true,
            rowSelection: {
                onChange: (selectedKeys: string[]) => {
                    this.setState({ selectedKeys });
                },
            },
            pagination: {
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '15', '20'],
                showTotal(total: number) {
                    return `共 ${total} 条记录`;
                },
            },
            scroll: {
                x: true,
            },
            columns: [
                {
                    property: 'name',
                    modifiable: false,
                },
                {
                    property: 'roomid',
                    modifiable: false,
                },
                {
                    property: 'dateTimeRange',
                    modifiable: false,
                },
                {
                    property: 'anchorName',
                    modifiable: false,
                },
                {
                    property: 'liveStatus',
                    modifiable: false,
                },
                {
                    property: 'showStatus',
                    width: 120,
                    displayConfig: {
                        statusConfig: {
                            DISPLAY: {
                                text: '是',
                            },
                            HIDE: {
                                text: '否',
                            },
                        },
                    },
                },
                {
                    property: 'sort',
                },
                {
                    property: 'recommend',
                },
            ],
            actionColumn: {
                title: '操作',
                width: 200,
                fixed: 'right',
                style: {
                    height: '80px',
                },
                items: [
                    {
                        type: 'component',
                        component: 'NoIntroduction',
                    },
                    {
                        type: 'component',
                        component: 'BatchShipmentPage',
                    },
                    {
                        type: 'component',
                        entity,
                        component: 'LiveRoomActionButton',
                    },
                    {
                        text: '编辑',
                        type: 'modify',
                        disabled: true,
                        statusKey: 'row.liveStatus',
                        params: {
                            liveStatus: 103,
                        },
                        config: {
                            type: 'link',
                        },
                    },
                    {
                        text: '保存',
                        type: 'modifyConfirm',
                        config: {
                            type: 'link',
                        },
                    },
                    {
                        text: '取消',
                        type: 'modifyCancel',
                        config: {
                            type: 'link',
                        },
                    },
                ],
            },
        };
        return createElement(ComponentsManager.get('DataTable'), liveRoomTable);
    }

    render() {
        return (
            <Fragment>
                {this.addActionBannerBtnRender()}
                {this.renderTable()}
            </Fragment>
        );
    }
}

export const liveRoomTable = connect()(liveRoomsTable);
